import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type AddSupplierType = {
  name: string;
};

const useAddSupplier = (
  options?: UseMutationOptions<any, Error, AddSupplierType>
) => {
  return useMutation({
    ...options,
    mutationKey: ['addSupplier'],
    mutationFn: async ({ name }) => {
      return axiosInstance.post('/suppliers', {
        name,
      }).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Dodawanie dostawcy...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'add-supplier',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Dostawca dodany pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'add-supplier',
      });
      
      queryClient.invalidateQueries({ queryKey: ['suppliers'] });
      
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas dodawania dostawcy.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'add-supplier',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useAddSupplier;
